import { CREDIT_CARD_FIELDS_NAMES } from '@ott/credit-card';

export const FORM_FIELDS = {
  amount: 'amount',
  selectedId: 'selectedId',
  ...CREDIT_CARD_FIELDS_NAMES,
} as const;

export const MANUAL_TYPE = '';

export const DEFAULT_BACK_REF = 'https://static.onetwotrip.com/redirect/redirect-result.html';

export const VISIBLE_CARDS = 3;
